// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"55cb4e16","108":"0e919023","196":"1c6d8530","356":"284fa347","540":"cc301a98","554":"7a3dbad2","787":"cda612ba","851":"75c2ee5b"}[chunkId] + ".chunk.js";
};